export default "__VITE_ASSET__b8932709__"